import styled from 'styled-components';

const Separator = styled.span`
  color: #000;
  font-weight: 700;
  margin-right: 5px;
`;

export default Separator;
